import { css } from "@emotion/css";
import { Dispatch, MutableRefObject, SetStateAction } from "react";
import { isNotUndefined, isUndefined } from "@/shared/FunctionCore";

const addIfNotNull =
	<T extends HTMLElement>(re: MutableRefObject<(T | null)[]>) =>
		(ht: T | null): void => {
			if (ht !== null) {
				re.current.push(ht);
			}
		};

const createMinHeightClass = (minHeight: number | undefined): string | undefined => (isNotUndefined(minHeight) ? css({ "minHeight": minHeight }) : void 0);

const getMaxHeight = (reference: MutableRefObject<(HTMLElement | null)[]>): number | undefined => {
	const offsetHeightArray = reference.current.map((ht) => ht?.offsetHeight);

	const offsetHeightNumberArray = offsetHeightArray.filter((nu): nu is number => typeof nu === "number");

	return offsetHeightArray.length === offsetHeightNumberArray.length ? window.Math.max(...offsetHeightNumberArray) : void 0;
};

export const updateMinHeight = (maxHeight: number | undefined, re: Dispatch<SetStateAction<number | undefined>>): void => {
	re((nu) => (isUndefined(maxHeight) ? nu : (isUndefined(nu) ? maxHeight : window.Math.max(nu, maxHeight))));
};

const filterOutUndefineds = <T>(array: (T | undefined)[]): T[] => {
	const newArray: T[] = [];

	for (const va of array) {
		if (isNotUndefined(va)) {
			newArray.push(va);
		}
	}

	return newArray;
};

const filterOutUndefinedsObj = object => {
	let newObject = {};
	const keys = Object.keys(object);

	keys.forEach(k => {
		if (isNotUndefined(object[k])) {
			newObject = { ...newObject, [k]: object[k]}
		}
	})
	return newObject;
};


enum LoadingState {
	Completed,
	InProgress,
	Initial,
}

export {
	addIfNotNull,
	createMinHeightClass,
	filterOutUndefineds,
	getMaxHeight,
	LoadingState,
	// updateMinHeight,
	filterOutUndefinedsObj
}
